module.exports = __webpack_public_path__ + "img/rak-7249.7d5de14a.png";